<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t0Td32/tc-custom/9781611523973.jpg?1723403952703" alt="This image is the cover for the book Colin and Martin's Goodbye Christmas, Colin and Martin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colin and Martin's Goodbye Christmas, Colin and Martin
      </h1>
      <p class="bookDescription body article font2">
        <p>The fourth and final Colin and Martin Christmas story sees the two men leaving Yorkshire to begin new lives in Australia.<br/><br/>Martin Kellam has no qualms about saying goodbye to what remains of his family, while Colin’s parting gift to Martin’s brother is a well-deserved punch in the nose.<br/><br/>Before leaving, the two men have one final Christmas in London with Colin’s parents, who are pulling out all the stops to make it an occasion to remember.<br/><br/>Martin enjoys teasing his husband. He knows Colin can never resist going in search of presents before Christmas Day. As this is their last winter Christmas, Martin boxes up a lump of coal and puts it somewhere where Colin will find it.<br/><br/>The festivities are brought to an abrupt halt when Colin’s mother reveals disturbing news that throws Colin and Martin’s emigration plans into turmoil.<br/><br/>Despite Martin’s much-needed comfort and reassurance, Colin is torn between family obligation and the future he and Martin have longed for. Can Martin show him that he can have both?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Drew Hunt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?628ccf98